import React, { useEffect, useState } from "react";
import { withRouter, Link, useHistory, useLocation } from "react-router-dom";
import "./LeagueSettings.css";
import CustomSelect from "../../../../../../../Util/CustomSelect/CustomSelect";
import LeagueLocationScheduleSection from "../../../Common/LeagueLocationScheduleSection";
import useSearchParam from "../../../../../../../hooks/UrlSearchParam";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../config";
import { LEAGUE_STATUS } from "../../../../../../../Util/helper";

function LeagueSettings(props) {
  const leagueId = useSearchParam(props.location).get('leagueId');
  const [leagueScheduleInfo, setLeagueScheduleInfo] = useState(null);
  const [payload, setPayload] = useState({});

  const [formSubmitted, setFormSubmitted] = useState(false);
  const history = useHistory();
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');

  useEffect(() => {
    getLeague(leagueId);

    //eslint-disable-next-line
  }, []);



  const getLeague = (league_id) => {
    axiosApi.get(`${config.apiUrl}/leagues/${league_id}`).then((resp) => {
      let leagueData = { ...resp.data.data };
      setLeagueScheduleInfo(leagueData);
      setPayload({ ...leagueData });

    }).catch((err) => {
      console.error(err);
    });
  }

  const handleSaveLeague = () => {
    setFormSubmitted(true);
    let data = {
      sport_id: payload.sport_id ? payload.sport_id : 0,
      season_id: payload.season_id ? payload.season_id : 0,
      name: payload.name ? payload.name : '',
      reg_deadline: payload.reg_deadline ? payload.reg_deadline : '',
      start_date: payload.start_date ? payload.start_date : '',
      reg_fees: Number(payload.reg_fees || 0),
      for_feit_fees: Number(payload.for_feit_fees || 0),
      team_size: Number(payload.team_size),
      play_level: payload.play_level ? payload.play_level : '',
      gender: payload.gender === 'Male' ? 'M' : payload.gender === 'Female' ? 'F' : 'C',
      men_per_team: Number(payload.men_per_team),
      women_per_team: Number(payload.women_per_team),
      // time_slots: payload.time_slots && payload.time_slots.length ? payload.time_slots : '',
      time_slots: payload.time_slots && payload.time_slots.length ? payload.time_slots.join(',') : '',
      days_played: payload.days_played && payload.days_played.length ? payload.days_played : null,
      elimination_type: payload.elimination_type ? payload.elimination_type : '',
      seeding: payload.seeding ? payload.seeding : '',
      hosted_by: payload.hosted_by,
      no_of_weeks: Number(payload.no_of_weeks || 0),
      no_of_games: Number(payload.no_of_games || 0),
      locations: payload.location ? (function (loc) {
        return loc.map((lc) => ({
          location_id: lc.location.id,
          field_id: lc.fields.map(x => x.id).join(','),
        }));
      }(payload.location)) : null,
      indv_reg_fees: Number(payload.indv_reg_fees || 0),
      status: payload.status ? payload.status : 'sign_up',
    }
    /* const objectSome = (key) => {
      if (['men_per_team', 'women_per_team', 'for_feit_fees', 'seeding', 'indv_reg_fees', 'seeding', 'no_of_games'].includes(key)) {
        return false;
      }
      if (typeof data[key] === 'string') {
        return !(data[key] || '').trim();
      }
      if (typeof data[key] === 'number') {
        return !data[key]
      }
      if (typeof data[key] === 'object' && Array.isArray(data[key])) {
        return !data[key].length;
      }
    }
    if (Object.keys(data).some(objectSome)) {
      return;
    } */
    if (leagueId) {
      axiosApi.put(`${config.apiUrl}/leagues/${Number(leagueId)}`, data).then(() => {
        setFormSubmitted(false);
        getLeague(leagueId);
      }).catch((err) => {
        console.error(err);
        setFormSubmitted(false);
      });
    }
  }

  const onChange = (resp) => {
    if (resp) {
      setPayload(prevData => ({
        ...prevData,
        [resp.type]: resp.data,
      }));
    }
  }

  return (
    <>
      <div className="league-settings">
        <div className="leagueSettings-header">
          <h2 className="heading">League Settings</h2>
          <div className="leagueSettings-header-actions">
          {['active', 'sign_up', 'need_schedule', 'complete'].includes(leagueScheduleInfo?.status) && <button className="btn" onClick={() => history.push(`/admin/leagues/sms-settings?leagueId=${leagueId}${(season_id) ? `&season_id=${season_id}` : ''}`, {
              type: 'edit',
              league_id: leagueId,
              from: 'league_settings_group',
            })}>SMS Settings</button>}
            <button className="btn" onClick={() => history.push(`/admin/leagues/league/${leagueId}${season_id ? `?season_id=${season_id}` : ''}`, {
              type: 'edit',
              league_id: leagueId,
              from: 'league_settings_group',
            })}>Advanced Settings</button>
          </div>
        </div>
        <div className="group-reminder">
          <div className="leagueSettings-body">

            <div className="input-wrapper">
              <CustomSelect
                uniqueKey={'League-Status-key'}
                required={true}
                data={[
                  {
                    id: "active",
                    title: "Active"
                  },
                  {
                    id: "complete",
                    title: "Complete"
                  },
                  {
                    id: "cancel",
                    title: "Cancel"
                  },
                  {
                    id: "sign_up",
                    title: "Sign-up"
                  },
                  {
                    id: 'need_schedule',
                    title: 'Needs Schedule',
                  },
                  {
                    id: "archive",
                    title: "Archive"
                  }
                ]}
                label={'League Status'}
                placeholder={payload && payload.status ? LEAGUE_STATUS[payload.status] : 'Select Status'}
                type={'status'}
                onSelect={(e) => e && onChange({ type: 'status', data: e?.id })}
                selector="title"
              />
            </div>
            <div className="input-blk">
              <span className="label">Sport - {payload.sport && payload.sport?.title ? payload.sport?.title : 'N/A'}</span>
              <Link to="/admin/leagues/sports"><button className="btn">Add/Modify Sports And Rules</button></Link>
            </div>
            {leagueScheduleInfo && <LeagueLocationScheduleSection formSubmitted={formSubmitted} data={leagueScheduleInfo} onChange={onChange} />}
          </div>
        </div>
      </div>
      <div className="footer-blk">
        <button onClick={handleSaveLeague}>Save Changes</button>
      </div>
    </>
  );
}

export default withRouter(LeagueSettings);
